export const mapFontStackUrl = "https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=N1yjrATaT1g6Bnt8iCH2";
